var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OnClickOutside',{on:{"click":function($event){return _vm.$emit('dismiss')}}},[_c('div',{ref:"content",class:_vm.isVisible ? 'd-block' : 'd-none'},[_c('LogsTable',{attrs:{"logs":_vm.logs,"is-loading":_vm.isLoading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }